export const searchType = {
  hotelList: 'hotelList',
  hotelPlanList: 'hotelPlanList'
}

export const BwPath = {
  GUEST_DETAIL: '/reservation/guest-detail',
  SEARCH_PAGE: '/booking/result',
  FACILITIES: '/facilities',
  MY_RESERVATIONS: '/my-account/reservations',
  OTA_SIGN_IN: '/ota-sign-in',
  CONFIRMATION: '/reservation/confirmation'
}
